export const FontSizeHTML = 14 as const;

export const RefreshTokenErrorMessage = "Refresh token does not exist" as const;

/**
 * Color variables use for "styles.ts" files and "style-inline"
 */
export const ColorVariables = {
  AntiFlashWhite: "#eef2f6",
  AntiFlashWhite2: "#f0f0f0",
  AuroMetalSaurus: "#697586",
  AzureishWhite: "#e3e8ef",
  Black: "#000",
  BrightNavyBlue: "#1976d2",
  Charcoal: "#364152",
  Corn: "#fff15d",
  DarkCoral: "#c65e3f",
  DodgerBlue: "#2196f3",
  EerieBlack: "#121926",
  FloralWhite: "#fffbf5",
  Gainsboro: "#d9d9d9",
  GhostWhite: "#f8fafc",
  Glitter: "#e3f2fd",
  KellyGreen: "#44b700",
  MediumCarmine: "#b34726",
  Seashell: "#fff2ed",
  Snow: "#fafafa",
  SpanishGray: "#999",
  Transparent: "transparent",
  White: "#fff",
} as const;

/**
 * zIndex variables use for "styles.ts" files and "style-inline"
 */
export const zIndexes = {
  Lottie: 999999,
  Popper: 9000, // Note: The value of "Popper" is equal to the "base" value of Modal
  Table: {
    StickyHeader: 101,
    StickyHeaderLeft: 102,
    StickyHeaderRight: 102,
    Loading: 103,
  },
} as const;
